import React from 'react'
import { useTranslation } from 'react-i18next'
import { SettingTab } from '@/components/molecules/settings/setting-tab'

type TabProps = {
  currentTab: 'rank' | 'baseRate' | 'calendar'
}

const ROOM_RATE_TABS = [
  { key: 'rank' as const, path: '/setting/room-rate-rank', name: 'Rate rank' },
  { key: 'baseRate' as const, path: '/setting/room-rate-base', name: 'Base rate' },
  { key: 'calendar' as const, path: '/setting/room-rate-calendar', name: 'Rate calendar' },
]

export const RoomRateTab: React.FC<TabProps> = ({ currentTab }) => {
  const { t } = useTranslation()
  const current = ROOM_RATE_TABS.find(tab => tab.key === currentTab) ?? ROOM_RATE_TABS[0]

  return <SettingTab currentTab={current.name} tabs={ROOM_RATE_TABS.map(({ path, name }) => ({ path, name }))} ariaLabel={t('Room rate')} />
}
